<ng-container *ngIf="createCodeView == null">
  <div class="modal-header">
    <h4 class="modal-title">Labor Allocations</h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'payroll_labor_allocations_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <fieldset [disabled]="isReadOnly">
      <div class="person-icon ms-2">
        <img class="ps-2" src="assets/icons/profile.svg" />
        <span class="px-2">{{ fullName }}</span>
      </div>
      <div class="d-flex mb-3">
        <div class="mx-auto">
          <label class="switch">
            <input type="checkbox" [(ngModel)]="isHoursView" (ngModelChange)="onViewChange()" />
            <span class="slider-toggle round"></span>
          </label>
        </div>
      </div>
      <div class="labor-allocations-table">
        <div class="wrapper d-flex" (scroll)="onTableScroll()">
          <div class="sticky-wrapper">
            <div class="sticky-col">
              <div class="sticky-header">
                {{ allocTypes[allocTypeId] }}
              </div>
              <div *ngFor="let allocation of allocations; let i = index" class="first-col">
                <ng-container
                  [ngTemplateOutlet]="deptSelect"
                  [ngTemplateOutletContext]="{ allocation: allocation, index: i }">
                </ng-container>
              </div>
            </div>
          </div>
          <table class="table" *ngIf="!isHoursView">
            <thead>
              <tr>
                <th>% Gross Pay</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let allocation of allocations; let i = index">
                <td>
                  <div class="input-group mb-0">
                    <input
                      appNumberInput
                      class="form-control mb-0"
                      id="column-{{ 2 }}-row-{{ i + 1 }}"
                      [(ngModel)]="allocation.Allocations.TemporaryPercentageAllocations"
                      (change)="onTempChange()"
                      (keydown)="onKeyDown($event, i + 1, 2)" />
                    <span class="input-group-append">
                      <span class="input-group-text">%</span>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- hours/wage view -->
          <table class="table" *ngIf="isHoursView">
            <thead>
              <tr>
                <ng-container *ngFor="let earning of earningsList">
                  <th *ngIf="earning.CanHaveRates || earning.IsPercentageEarning">
                    {{ earning.Name }}&nbsp;
                    <i class="fas fa-dollar-sign cp-green"></i>
                  </th>
                  <th *ngIf="earning.CanSetHours">
                    {{ earning.Name }}&nbsp;
                    <i class="far fa-clock cp-green"></i>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let allocation of allocations; let i = index">
                <ng-container *ngFor="let earning of earningsList; let idx = index">
                  <td *ngIf="earning.CanHaveRates || earning.IsPercentageEarning">
                    <div class="input-group mb-0">
                      <span
                        class="input-group-prepend input-group-text"
                        *ngIf="!earningConfigs[earning.Id].IsPercentageEarning"
                        >$</span
                      >
                      <input
                        id="column-{{ idx + 2 }}-row-{{ i + 1 }}"
                        appNumberInput
                        style="min-width: 100px"
                        (keydown)="onKeyDown($event, i + 1, idx + 2)"
                        class="form-control"
                        (change)="onTempChange()"
                        [decimals]="earningConfigs[earning.Id].CalculationMethod == 1 ? 4 : 2"
                        [(ngModel)]="
                          allocation.Allocations.TemporaryHourlyAllocations[earning.Id]
                            .TemporaryRateAmount
                        " />
                      <span
                        *ngIf="earningConfigs[earning.Id].IsPercentageEarning"
                        class="input-group-append input-group-text input-group-text"
                        >%</span
                      >
                    </div>
                  </td>
                  <td *ngIf="earning.CanSetHours">
                    <input
                      id="column-{{ idx + 2 }}-row-{{ i + 1 }}"
                      appNumberInput
                      style="min-width: 100px"
                      (keydown)="onKeyDown($event, i + 1, idx + 2)"
                      class="form-control mb-0"
                      (change)="onTempChange()"
                      [decimals]="earningConfigs[earning.Id].CalculationMethod == 1 ? 4 : 2"
                      [(ngModel)]="
                        allocation.Allocations.TemporaryHourlyAllocations[earning.Id].Hours
                      " />
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button class="btn btn-xs mt-1" (click)="addAllocation()">
        <i class="fas fa-xs fa-plus"></i>&nbsp;Add new allocation
      </button>
    </fieldset>
  </div>
  <div class="modal-footer pb-4">
    <button
      cpGTagEvent
      [params]="{ event_label: 'payroll_labor_allocation_modal_cancel' }"
      type="button"
      class="btn btn-secondary"
      (click)="activeModal.dismiss()">
      Cancel
    </button>
    <div (mouseenter)="showFormError = true">
      <button
        cpGTagEvent
        [params]="{ event_label: 'payroll_labor_allocation_modal_save', data: allocations }"
        type="button"
        class="btn btn-primary"
        (click)="onSave(activeModal)"
        [attr.disabled]="!isFormDirty || formError || isReadOnly ? 'disabled' : null">
        Save
      </button>
    </div>
    <div class="position-absolute bottom-0">
      <span *ngIf="showFormError" style="color: #ff4300; font-size: small">
        {{ formError }}
      </span>
    </div>
  </div>
</ng-container>

<!-- add new dept/job code view -->
<ng-container *ngIf="createCodeView != null">
  <div class="modal-header">
    <h4 class="modal-title">New {{ allocTypes[allocTypeId] }}</h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'payroll_labor_allocations_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <label>{{ allocTypes[allocTypeId] }}</label>
      <input
        class="form-control"
        [(ngModel)]="newCode.Id"
        placeholder="{{ allocTypes[allocTypeId] }}..."
        appAutoFocus />
      <label>Description</label>
      <input class="form-control" [(ngModel)]="newCode.Value" placeholder="Description..." />
    </div>
  </div>
  <div class="modal-footer pb-4">
    <button type="button" class="btn btn-secondary" (click)="createCodeView = null">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveNewCode()"
      cpGTagEvent
      [params]="{ event_label: 'payroll_labor_allocations_add_new_code', data: newCode }">
      Add
      {{ allocTypes[allocTypeId] }}
    </button>
  </div>
</ng-container>

<!-- dept/job code selection -->
<ng-template #deptSelect let-allocation="allocation" let-index="index">
  <div
    class="d-flex align-items-center"
    [title]="allocation.Id ? getJobCodeDisplay(allocation.Id) : ''">
    <button
      class="btn btn-link"
      (click)="deleteAllocation(index)"
      style="color: black"
      [attr.disabled]="allocations.length == 1 ? 'disabled' : null">
      <i class="far fa-lg fa-trash-alt"></i></button
    >&nbsp;
    <div
      class="ng-autocomplete"
      [ngClass]="{ invalid: codeIndexErrors[index] }"
      (keydown)="onKeyDown($event, index + 1, 1, true)"
      id="column-1-row-{{ index + 1 }}">
      <ng-autocomplete
        #auto
        [ngModel]="allocation.Id"
        [data]="codeOptions"
        [searchKeyword]="keyword"
        [focusFirst]="true"
        (selected)="onCodeSelect($event, index)"
        (inputFocused)="onCodeFocus(index)"
        [selectedValueRender]="selValueRender"
        (inputChanged)="onCodeChange($event, index)"
        (inputCleared)="onCodeClear(index)"
        [itemTemplate]="itemTemplate"
        (opened)="autoCompleteOpened(index)"
        [notFoundTemplate]="notFoundTemplate"
        [disabled]="isReadOnly">
      </ng-autocomplete>
      <div *ngIf="codeIndexErrors[index]" class="input-error input-group-error">
        *invalid {{ allocTypes[allocTypeId] }}
      </div>
      <div *ngIf="codeIndexErrors[index] && showFormError" class="input-error input-group-error">
        *invalid {{ allocTypes[allocTypeId] }}
      </div>
      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.Value"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
        <a *ngIf="allocTypeId == allocTypes['Job Code']" (click)="addNewDept(index)">
          <strong>Add New {{ allocTypes[allocTypeId] }}</strong>
        </a>
        <span *ngIf="allocTypeId != allocTypes['Job Code']">
          <strong>No results found</strong>
        </span>
      </ng-template>
    </div>
  </div>
</ng-template>
